import {
  type Action,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";
import type { ControlType } from "./AnalyticsProvider";

type BaseOnboardingExtras = {
  id: string;
  step?: number;
  // For game-related events
  gameId?: string;
  gameName?: string;
};

type OnboardingPressedEvent = {
  action: Action.PRESSED;
  extras: BaseOnboardingExtras & {
    control: string;
    controlType: ControlType;
  };
};

type OnboardingViewedEvent = {
  action: Action.VIEWED;
  extras: BaseOnboardingExtras & {
    isAccountFlagged?: boolean;
  };
};

type OnboardingSucceededEvent = {
  action: Action.SUCCEEDED;
  extras: BaseOnboardingExtras;
};

export type OnboardingEvent =
  | OnboardingViewedEvent
  | OnboardingPressedEvent
  | OnboardingSucceededEvent;

export const useOnboardingAnalytics = () =>
  useAnalyticsTracker<OnboardingEvent>(TrackObject.ONBOARDING);
